Ext.define('SA.SidebarPanels', {
    alias: 'widget.sidebar-panels',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-sidebar-panels',

    items: [
        {
            xtype: 'empty-sidebar',
            cls: 'sa-sidebar-section',
            id: 'empty-sidebar',
        }, {
            xtype: 'locations-sidebar',
            cls: 'sa-sidebar-section',
            id: 'locations-sidebar',
            hidden: true
        }, {
            xtype: 'scarborough-locations-sidebar',
            cls: 'sa-sidebar-section',
            id: 'scarborough-locations-sidebar',
            hidden: true
        }, {
            xtype: 'businesses-sidebar',
            cls: 'sa-sidebar-section',
            id: 'businesses-sidebar',
            hidden: true
        }, {
            xtype: 'data-sidebar',
            cls: 'sa-sidebar-section',
            id: 'data-sidebar',
            hidden: true
        }
    ],

    initComponent() {
        this.callParent();

        this.panels = {
            empty: this.down('empty-sidebar'),
            data: this.down('data-sidebar'),
            businesses: this.down('businesses-sidebar'),
            defaultLocations: this.down('locations-sidebar'),
            scarboroughLocations: this.down('scarborough-locations-sidebar')
        };
    },

    afterRender() {
        this.callParent();

        Object.values(this.panels).forEach(panel => {
            panel.getEl().dom.setAttribute('role', 'tabpanel');
        });
    },

    getDataPanel() {
        return this.panels.data;
    },

    refreshDataPanel() {
        if (this.model) {
            this.panels.data.setView(this.model);
        }
    },

    setHandlers(handlers) {
        this.setUseAttributeHandler(handlers?.data ?? null);
        this.setUseLocationHandler(handlers?.locations ?? null);
    },

    setModel(model) {
        this.model = model;

        this.panels.data.setView(model);
        this.panels.businesses.setProjectView(model);
        this.panels.defaultLocations.setProjectView(model);
        this.panels.scarboroughLocations.setView(model);
    },

    setSelectedType(type) {
        var locationsPanel = this.model?.getType() === 'scarboroughCrosstab' ? this.panels.scarboroughLocations : this.panels.defaultLocations,
            selectedPanel = type === 'locations' ? locationsPanel : this.panels[type];

        Object.values(this.panels).forEach(panel => panel.setVisible(panel === selectedPanel));
    },

    setUseAttributeHandler(handler) {
        this.panels.data.setUseHandler(handler);
    },

    setUseLocationHandler(handler) {
        this.panels.defaultLocations.setUseHandler(handler);
    }
});
